export const DEFAULT_LANDING_PAGE_PATH = 'aca-in-accs';
export const DEFAULT_MARKET_SLUG = 'academy-in';
export const SUPPORTED_MARKET_SLUGS = ['academy-de', 'academy-es', 'academy-in', 'academy-it', 'academy-us'] as const;

// Landing-page slugs are the canonical identifier AND the public URL: aca-<country>-<theme>
// (e.g. aca-in-accs). ROUTE_ALIASES only maps optional convenience shortcuts onto a slug;
// a canonical slug resolves to itself and needs no entry here.
export const ROUTE_ALIASES = {
  'academy-de': 'aca-de-qm',
  'academy-es': 'aca-es-incompany',
  'academy-in': 'aca-in-accs',
  'academy-it': 'aca-it-sustainability',
  'academy-us': 'aca-us-fusa-machinery',
  'qm-landingpage': 'aca-de-qm',
} as const;

export function normalizePathname(pathname: string): string {
  return pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
}

export function getInitialPathname(): string {
  if (typeof window === 'undefined') return '/';
  return window.location.pathname || '/';
}

export function getMarketSlug(pathname: string): string | null {
  // Slugs look like aca-<country>-<theme>; derive the market (academy-<country>) from the prefix.
  const match = /^aca-([a-z]{2})-/.exec(resolveLandingPagePath(pathname));
  if (!match) return null;
  const candidate = `academy-${match[1]}`;
  return (SUPPORTED_MARKET_SLUGS as readonly string[]).includes(candidate) ? candidate : null;
}

export function resolveLandingPagePath(pathname: string): string {
  const normalizedPath = normalizePathname(pathname);
  return ROUTE_ALIASES[normalizedPath as keyof typeof ROUTE_ALIASES] ?? normalizedPath;
}

export function getPublicLandingPagePath(internalPath: string): string {
  // Slug and public path are identical (aca-<country>-<theme>).
  return internalPath;
}
